<template>
  <FormContainer>
    <template #title>Coordonnées du salarié(e)</template>
    <template #content>
      <div class="form__bloc">
        <WrapperInput
          id="field_17"
          v-model="voieModel"
          :label="LABEL_NUMERO_VOIE"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_ADR_VOIE"
          :required="meta.salarie?.adresse?.voie?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.adresse?.voie?.$messageErreurDirty!"
          :maxlength="38"
          deletable
          :readonly
        />
        <WrapperInput
          id="field_18"
          v-model="complementAdresseModel"
          label="Complément d'adresse"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_ADR_COMPLEMENT"
          :required="meta.salarie?.adresse?.complement?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.adresse?.complement?.$messageErreurDirty!"
          :maxlength="38"
          deletable
          :readonly
        />
        <WrapperInput
          id="field_19"
          v-model="codePostalModel"
          label="Code postal"
          class="col-4 col-md-6 col-sm-36"
          :placeholder="PLACEHOLDER_ADR_CP"
          :required="meta.salarie?.adresse?.codePostal?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.adresse?.codePostal?.$messageErreurDirty!"
          :maxlength="5"
          deletable
          :readonly
        />
        <WrapperInput
          id="field_20"
          v-model="communeModel"
          label="Commune"
          class="col-8 col-md-12 col-sm-36"
          :placeholder="PLACEHOLDER_ADR_VILLE"
          :required="meta.salarie?.adresse?.commune?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.adresse?.commune?.$messageErreurDirty!"
          :maxlength="50"
          deletable
          :readonly
        />
      </div>
      <div class="form__bloc">
        <WrapperInputTelephone
          id="field_21"
          v-model="telephoneModel"
          label="Téléphone"
          :required="meta.salarie?.telephone?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.telephone?.$messageErreurDirty!"
          class="col-6 col-md-12 col-sm-36"
          :placeholder="PLACEHOLDER_TEL"
          :maxlength="10"
          deletable
          :readonly
        />
        <WrapperInput
          id="field_22"
          v-model="emailModel"
          label="Email"
          :required="meta.salarie?.email?.$status === PropertyStatus.Required"
          :alertLabel="meta.salarie?.email?.$messageErreurDirty!"
          hint="64 caractères maximum"
          class="col-10 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_EMAIL"
          :maxlength="64"
          deletable
          :readonly
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { storeToRefs } from 'pinia'
  import {
    FormContainer,
    PLACEHOLDER_ADR_VOIE,
    PLACEHOLDER_ADR_COMPLEMENT,
    PLACEHOLDER_ADR_CP,
    PLACEHOLDER_ADR_VILLE,
    PLACEHOLDER_TEL,
    PLACEHOLDER_EMAIL,
    LABEL_NUMERO_VOIE,
    DEMANDE_STORE,
  } from '@/features/interface/demande/shared'
  import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'
  import { inject } from 'vue'

  const store = inject(DEMANDE_STORE)!.getStore('MODEL_CXPI')
  const { setupFieldWithKey } = store
  const { meta, readonly } = storeToRefs(store)

  const voieModel = setupFieldWithKey<string>('salarie.adresse.voie', true)
  const complementAdresseModel = setupFieldWithKey<string>('salarie.adresse.complement', true)
  const codePostalModel = setupFieldWithKey<string>('salarie.adresse.codePostal', true)
  const communeModel = setupFieldWithKey<string>('salarie.adresse.commune', true)
  const telephoneModel = setupFieldWithKey<string>('salarie.telephone', true)
  const emailModel = setupFieldWithKey<string>('salarie.email', true)
</script>
